import course1 from "../assets/assets_updated/course1.png";
import course2 from "../assets/assets_updated/course2.png";
import course3 from "../assets/assets_updated/course3.png";

const ProjectCardData = [
    {
        imgsrc: course1,
        title: "Coursera: Machine Learning Fundamentals for Supervised Learning",
        text: "Completed: January 2024. Ask me about feature selection, linear regression, gradient descent, logistic regression, classification, training, validation, and more! I took this course because I see myself using these topics in my own projects, so I will often refresh myself on these.",
        view: "https://coursera.org/share/e6d7427552962c45714a9512c714c6ab",
        source: "https://coursera.org/share/e6d7427552962c45714a9512c714c6ab"
    },
    {
        imgsrc: course2,
        title: "Coursera: Unsupervised Learning and Neural Networks",
        text: "Completed: January 2024. The strategies I learned in this course is currently an ACTIVE PROJECT (2025). I intend to use data generation (creating synthetic data) to create a large plant dataset, along with TensorFlow and transfer learning to build a simple plant disease detection project. Look for a demo on this project shortly.",
        view: "https://coursera.org/share/bf1e840b1fcb3559537b57573d1a98ae",
        source: "https://coursera.org/share/bf1e840b1fcb3559537b57573d1a98ae"

    },
    {
        imgsrc: course3,
        title: "Coursera: Advanced Algorithms: Reinforcement Learning, Anomaly Detection, Random Forests, and more",
        text: "Completed: January 2024. Ask me about decision trees, random forests, reinforcement learning, anomaly detection, principal component analysis, and more! I'll likely not be using these topics as much at least in any projects this year, but decision trees may be useful for the home automation development I have in the works. Landing page will be shared in the projects section soon.",
        view: "https://coursera.org/share/61fb74347e6458a46ed49f8f0fccd24e",
        source: "https://coursera.org/share/61fb74347e6458a46ed49f8f0fccd24e"
    }
]

export default ProjectCardData;